import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../assets/css/HeaderWebsite.css";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  linkWhatsapp,
  linkYoutube,
  linkInstagram,
} from "../global/GlobalVariables";
import supportLogoDark from "../assets/svg/headset-dark-mode.svg";

function SubNavbar(props) {
  const {
    notificationVolume,
    setNotificationVolume
  } = props;
  const instalogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-instagram-96.png`;
  const youtlogo = `${process.env.PUBLIC_URL}/svgimagens/icons8-reproduzir-youtube-96.png`;
  const logobranca = `${process.env.PUBLIC_URL}/LOGOBRANCO.png`;


  const shouldShowLogoutButton = () => {
    const hash = window.location.hash;

    if (hash === "" || hash === "/") {
      return true;
    }

    if (hash.includes("/calculator/")) {
      return false;
    }

    if (hash.includes("/calculator/")) {
      return false;
    }

    const currentPath = window.location.pathname;

    if (currentPath === "/") {
      return true;
    }

    if (currentPath.includes("/calculator/")) {
      return false;
    }

    return true;
  };

  const [volume, setVolume] = useState(notificationVolume);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {}, [volume]);

  const handleVolumeChange = (event) => {
    const newVolume = parseFloat(event.target.value);

    setNotificationVolume(newVolume);
    localStorage.setItem("volume", JSON.stringify(newVolume));
    setVolume(newVolume);
    setIsMuted(newVolume === 0);
    setNotificationVolume(parseFloat(event.target.value));
  };



  return (
    <>
      {["lg"].map((expand) => (
        <Navbar
          key={expand}
          expand={false}
          className={`bg-body-tertiary header d-flex justify-content-between align-items-center navbar navbar-expand-xxl zete  navbar-dark ResponsivHeader dark-mode`}
        >
          <Container fluid>
            <Navbar.Brand href="#" style={{ margin: "0" }}>
              <NavLink to="/">
                <a
                  className={`text-decoration-none fs-5 me-3 textDark`}
                >
                  <img
                    src={logobranca}
                    alt="Logo"
                    style={{ height: "55px", width: "auto" }}
                    className="imgfullhd"
                  />
                </a>
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-xxl`}
              className="margin20px"
            />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-xxl`}
              aria-labelledby={`offcanvasNavbarLabel-expand-xxl`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xxl`}>
                  <a
                    className={`text-decoration-none fs-5 me-3 textDark`}
                    href="/"
                  >
                    <img
                      src={logobranca}
                      alt="Logo"
                      style={{ height: "55px", width: "auto" }}
                      className="imgfullhd"
                    />
                  </a>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {shouldShowLogoutButton() && (
                  <div className="social div-social-media">
                    <a
                      href={linkInstagram}
                      target="_blank"
                      rel="noreferrer"
                      className="social-link"
                    >
                      <img
                        src={instalogo}
                        alt="Instagram"
                        className="social-icon insta"
                      />
                    </a>
                    <div className="space-icon"></div>
                    <a
                      href={linkYoutube}
                      target="_blank"
                      rel="noreferrer"
                      className="social-link"
                    >
                      <img
                        src={youtlogo}
                        alt="YouTube"
                        className="social-icon youtube"
                      />
                    </a>
                    <div className="space-icon"></div>
                    <a
                      href={linkWhatsapp}
                      target="_blank"
                      rel="noreferrer"
                      className="social-link"
                    >
                      <img
                        src={supportLogoDark}
                        alt="Suport Logo"
                        className="social-icon"
                      />
                    </a>
                  </div>
                )}

                <div className="div-btn-menu menu mudanca-menu">
                  
                </div>
                <Navbar.Collapse
                  className="justify-content-end navbar-end"
                  style={{ display: "ruby-text", justifyContent: "center" }}
                >
                  <Navbar.Text>
                    <div className="d-flex align-items-center ">
                      
                      <div
                        className={`form-check form-switch me-2 dark-switch`}
                      >
                       <NavLink to="/">
                              <li className="nav-link">
                                <span className="navlink">
                                  <a className="linknavbar">
                                    <b
                                      className={`text-light`}
                                    >
                                      LOGIN{" "}
                                    </b>
                                  </a>
                                </span>
                              </li>
                            </NavLink>
                    </div>
                    </div>
                  </Navbar.Text>
                </Navbar.Collapse>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default SubNavbar;
